<template>
  <div v-if="selectedAcademy && canSelectAcademy" class="academy-header-banner">
    <div class="academy-banner-content">
      <div class="academy-info-section">
        <v-icon class="academy-icon">
          {{ icons.mdiSchool }}
        </v-icon>
        <span class="academy-text">
          <span class="working-text">WORKING ON BEHALF OF:</span>
          <span class="academy-name">{{ selectedAcademy.name }}</span>
        </span>
      </div>

      <v-btn
        small
        outlined
        color="white"
        class="academy-exit-btn"
        @click="clearSelectedAcademy"
      >
        <v-icon small left style="margin-right: 4px;">
          {{ icons.mdiClose }}
        </v-icon>
        Exit Academy Mode
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mdiSchool, mdiClose } from '@mdi/js'
import useAcademySelection from '@/composables/useAcademySelection'

export default {
  name: 'AcademyHeaderInfo',

  setup() {
    const { selectedAcademy, canSelectAcademy, clearSelectedAcademy } = useAcademySelection()

    return {
      selectedAcademy,
      canSelectAcademy,
      clearSelectedAcademy,
      icons: {
        mdiSchool,
        mdiClose,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.academy-header-banner {
  background: linear-gradient(98deg, #c48eff, var(--v-primary-base) 94%);
  color: white;
  padding: 8px;
  margin-right: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 3px solid white;
  border-radius: 12px;
  display: inline-flex;
  width: 100%;

  .academy-banner-content {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: space-between;
  }

  .academy-info-section {
    display: flex;
    align-items: center;

    .academy-icon {
      font-size: 20px;
      margin-right: 8px;
      color: white;
    }

    .academy-text {
      display: flex;
      flex-direction: column;
      line-height: 1.1;

      .working-text {
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.8px;
        opacity: 1;
        text-transform: uppercase;
      }

      .academy-name {
        font-size: 13px;
        font-weight: 700;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      }
    }
  }

  .academy-exit-btn {
    border: none;
    background: white;
    color: rgba(94, 86, 105, 1) !important;
    font-weight: 600;
    padding: 2px 8px !important;
    border-radius: 6px !important;
    font-size: 11px !important;
    min-width: auto !important;
    height: 28px !important;

    &:hover {
      background-color: rgba(255, 255, 255, .9) !important;
      transform: translateY(0);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

// Mobile styles - when displayed below header
@media (max-width: 768px) {
  .academy-header-banner {
    margin: 0;
    padding: 12px 16px;
    border-radius: 8px;
    width: 100%;
    justify-content: space-between;

    .academy-banner-content {
      width: 100%;
      justify-content: space-between;
    }

    .academy-info-section {
      .academy-icon {
        font-size: 24px;
        margin-right: 12px;
      }

      .academy-text {
        .working-text {
          font-size: 12px;
        }

        .academy-name {
          font-size: 15px;
        }
      }
    }

    .academy-exit-btn {
      padding: 6px 12px !important;
      font-size: 12px !important;
      height: 32px !important;
    }
  }
}

// Special styles for sticky banner at bottom
::v-deep .mobile-academy-banner-sticky {
  .academy-header-banner {
    background: none !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;

    .academy-banner-content {
      padding: 0;
    }
  }
}
</style>
